import { createFileRoute } from '@tanstack/react-router';
import { useTableDisplayState } from '@/components/DataTable';
import { VStack } from '@/components/Layout';
import PageHeader from './-components/PageHeader';
import Table from './-components/Table';
import TableHeader from './-components/TableHeader';
import useGetExternalHrSaasAppIntegrations from './-queries/useGetExternalHrSaasAppIntegrations';
export const Route = createFileRoute('/_staff/person/external-hr-saas/')({
  component: RouteComponent
});
function RouteComponent() {
  const {
    data,
    isPending
  } = useGetExternalHrSaasAppIntegrations();
  const displayState = useTableDisplayState(isPending, data.groups);
  return <VStack className="mx-auto w-[1000px] py-12 gap-8">
      <PageHeader />

      <VStack className="gap-6">
        <TableHeader />
        <Table data={data ?? {
        groups: [],
        totalCount: 0
      }} displayState={displayState} />
      </VStack>
    </VStack>;
}